export default "__VITE_ASSET__C$lNwtdD__"